import { Injectable } from '@angular/core';
import swal from 'sweetalert2';

@Injectable()

export class loadingService
{

    loading = false;

    constructor(){}

    ngOnInit()
    {

    }

    showLoading()
    {
        if(this.loading == false)
        {
            this.loading = true;
            swal({
                title: "Procesando",
                text: "Aguarde un momento estamos trabajando",
                allowOutsideClick: false,
                onBeforeOpen: () =>
                {
                    swal.showLoading()
                }
            });
        }
        
    }
    closeLoading()
    {
        this.loading = false;
        swal.close();
    }

}




// WEBPACK FOOTER //
// ./src/app/core/service/loading.service.ts